import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';
import { COLOR_WHITE } from 'styles/variables/colors';

// Winter themed colors
const WINTER_BLUE = '#1e3a8a'; // Dark blue
const WINTER_LIGHT_BLUE = '#3b82f6'; // Lighter blue

export const DiscountBanner = styled(Box)(({ theme }) => ({
  backgroundColor: WINTER_BLUE,
  paddingBottom: '8px',
  paddingTop: '8px',
  paddingLeft: '40px',
  paddingRight: '40px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(0.75),
  width: '100%',
  position: 'relative',
  flexDirection: 'column',

  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(4),
    flexDirection: 'row',
    justifyContent: 'center',
  },
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.55),
}));

export const ChristmasIcon = styled('span')(({ theme }) => ({
  fontSize: '20px',
}));

export const DiscountText = styled(Typography)(({ theme }) => ({
  color: COLOR_WHITE,
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '18px',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: '10px',
    lineHeight: '16px',
  },
}));

export const CtaButton = styled(Button)(({ theme }) => ({
  backgroundColor: `${WINTER_LIGHT_BLUE} !important`,
  color: `${COLOR_WHITE} !important`,
  fontFamily: 'Lato, sans-serif',
  fontWeight: 700,
  fontSize: '12px',
  lineHeight: '16px',
  padding: theme.spacing(1, 2),
  borderRadius: '20px !important',
  textTransform: 'none',
  border: 'none',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  minWidth: '100px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: `${WINTER_LIGHT_BLUE} !important`,
    opacity: 0.9,
  },
  '&:active': {
    transform: 'translateY(0)',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '13px',
    lineHeight: '18px',
    padding: theme.spacing(1.5, 3),
  },
}));
